
import { useEffect } from "react";
import HomeHeader from "@/components/HomeHeader";
import Footer from "@/components/Footer";
import PersonalWelcomeSection from "@/components/sections/PersonalWelcomeSection";
import PersonalStrategiesDashboard from "@/components/sections/PersonalStrategiesDashboard";
import { useAuthState } from "@/hooks/useAuthState";

const Home = () => {
  const { user } = useAuthState();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HomeHeader />
      <main>
        <PersonalWelcomeSection />
        {user && <PersonalStrategiesDashboard />}
      </main>
      <Footer />
    </div>
  );
};

export default Home;
